import { render, staticRenderFns } from "./agenzie-associazioni.vue?vue&type=template&id=26bafb09&"
import script from "./agenzie-associazioni.vue.ts?vue&type=script&lang=ts&"
export * from "./agenzie-associazioni.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports